// Core
import React from 'react';
import {render} from 'react-dom'
import {Router, Route, hashHistory} from 'react-router'

// Styles
import style from '../styles/styles.scss';

// Compontents
import SmoothScroll from './helpers/smoothscroll'
import Navbar from './components/navbar.jsx'
import Footer from './components/footer.jsx'

new SmoothScroll

// Pages
import Home from './pages/home.jsx';
import About from './pages/about.jsx';
import Impressum from './pages/impressum.jsx';
import CategoryXbow from './pages/categories/xbow.jsx';
import CategoryBoldideas from './pages/categories/boldideas.jsx';
import CategoryLookbook from './pages/categories/lookbook.jsx';
import CategoryVisualbranding from './pages/categories/visualbranding.jsx';
import CategoryStorytelling from './pages/categories/storytelling.jsx';
import CategoryPeople from './pages/categories/people.jsx';


render((
    <div>
        <Navbar></Navbar>
        <Router history={hashHistory}>
            <Route path="/" component={Home}/>
            <Route path="/about" component={About}/>
            <Route path="/impressum" component={Impressum}/>
            <Route path="/categories/xbow" component={CategoryXbow}/>
            <Route path="/categories/boldideas" component={CategoryBoldideas}/>
            <Route path="/categories/lookbook" component={CategoryLookbook}/>
            <Route path="/categories/visualbranding" component={CategoryVisualbranding}/>
            <Route path="/categories/storytelling" component={CategoryStorytelling}/>
            <Route path="/categories/people" component={CategoryPeople}/>
        </Router>
    </div>
), document.getElementById('app'))




// WEBPACK FOOTER //
// ./src/scripts/main.jsx